import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { TranslationService } from '../../../services/translation/translation.service';

@Component({
  selector: 'insert-text-dialog',
  templateUrl: './insert-text-dialog.component.html',
  styleUrl: './insert-text-dialog.component.css'
})
export class InsertTextDialogComponent {

  text = "";
  constructor(private dialogRef: MatDialogRef<InsertTextDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: {title: string, subtitle: string}, private translationService: TranslationService) {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if(this.text != undefined && this.text != "")
    this.dialogRef.close(this.text);
  }
}


